import { useState, useEffect } from 'react';
import api from '../services/api';

export default function ServiceAreas() {
  var [areas, setAreas] = useState([]);
  var [loading, setLoading] = useState(true);
  var [search, setSearch] = useState('');
  var [showForm, setShowForm] = useState(false);
  var [form, setForm] = useState({ district: '', city: '', area_code: '', latitude: '', longitude: '', radius_km: 10 });
  var [editId, setEditId] = useState(null);
  var [saving, setSaving] = useState(false);
  var [cityQuery, setCityQuery] = useState('');
  var [cityResults, setCityResults] = useState([]);
  var [searching, setSearching] = useState(false);

  useEffect(function() { load(); }, []);

  function load() {
    setLoading(true);
    api.get('/service-areas/').then(function(r) { setAreas(r.data); setLoading(false); }).catch(function() { setLoading(false); });
  }

  function handleAdd(e) {
    e.preventDefault();
    setSaving(true);
    var payload = {
      district: form.district,
      city: form.city,
      area_code: form.area_code.toUpperCase(),
      latitude: parseFloat(form.latitude),
      longitude: parseFloat(form.longitude),
      radius_km: parseFloat(form.radius_km),
    };
    var req = editId ? api.put('/service-areas/' + editId, payload) : api.post('/service-areas/', payload);
    req.then(function() {
      setShowForm(false);
      setEditId(null);
      setForm({ district: '', city: '', area_code: '', latitude: '', longitude: '', radius_km: 10 });
      load();
    }).catch(function(err) { alert(err.response?.data?.detail || 'Failed'); });
    req.finally(function() { setSaving(false); });
  }

  function handleEdit(a) {
    setEditId(a.id);
    setForm({ district: a.district, city: a.city, area_code: a.area_code || '', latitude: String(a.latitude), longitude: String(a.longitude), radius_km: a.radius_km });
    setShowForm(true);
    setTimeout(function() {
      var el = document.getElementById('area-edit-form');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function handleToggle(id) {
    api.put('/service-areas/' + id + '/toggle').then(function() {
      setAreas(function(prev) {
        return prev.map(function(a) { return a.id === id ? Object.assign({}, a, { is_active: !a.is_active }) : a; });
      });
    }).catch(function() {});
  }

  function handleDistrictToggle(district) {
    api.put('/service-areas/district-toggle/' + encodeURIComponent(district)).then(function() { load(); }).catch(function() {});
  }

  function handleDelete(id, name) {
    if (!window.confirm('Delete ' + name + '?')) return;
    api.delete('/service-areas/' + id).then(function() { load(); }).catch(function() {});
  }

  // Search city using Nominatim - triggers as user types (debounced)
  function searchCity(query) {
    setCityQuery(query);
    if (query.length < 3) { setCityResults([]); return; }
    setSearching(true);
    fetch('https://nominatim.openstreetmap.org/search?q=' + encodeURIComponent(query + ', Telangana, India') + '&format=json&limit=5')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        setCityResults(data.map(function(r) {
          return { name: r.display_name.split(',')[0], fullName: r.display_name, lat: parseFloat(r.lat), lng: parseFloat(r.lon) };
        }));
        setSearching(false);
      }).catch(function() { setCityResults([]); setSearching(false); });
  }

  function selectCity(city) {
    setForm(function(prev) { return Object.assign({}, prev, { city: city.name, latitude: String(city.lat.toFixed(4)), longitude: String(city.lng.toFixed(4)) }); });
    setCityResults([]);
    setCityQuery('');
  }

  // Group by district
  var q = search.toLowerCase();
  var filtered = areas.filter(function(a) { return a.district.toLowerCase().includes(q) || a.city.toLowerCase().includes(q); });
  var districts = {};
  filtered.forEach(function(a) {
    if (!districts[a.district]) districts[a.district] = [];
    districts[a.district].push(a);
  });
  var totalActive = areas.filter(function(a) { return a.is_active; }).length;

  return (
    <div>
      <div className="page-header">
        <h1>Service Areas</h1>
        <p>Manage cities and towns where HomeChamp operates. Active: {totalActive} / {areas.length}</p>
      </div>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <input placeholder="Filter district or city..." value={search} onChange={function(e) { setSearch(e.target.value); }}
          style={{ padding: '8px 14px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, flex: 1, minWidth: 200 }} />
        <button className="btn btn-primary" onClick={function() { setShowForm(!showForm); setEditId(null); setForm({ district: '', city: '', area_code: '', latitude: '', longitude: '', radius_km: 10 }); }}>+ Add Area</button>
        <button className="btn btn-sm" style={{background: totalActive > 0 ? '#dc2626' : '#16a34a', color:'#fff'}}
          onClick={function() { api.put('/service-areas/toggle-all').then(function() { load(); }); }}>
          {totalActive > 0 ? '🔴 All OFF' : '🟢 All ON'}
        </button>
        <button className="refresh-btn" onClick={load}>Refresh</button>
      </div>

      {/* Add/Edit Form with built-in city search */}
      {showForm && (
        <div className="card" id="area-edit-form" style={{ marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0 }}>{editId ? 'Edit Service Area' : 'Add New Service Area'}</h3>
            <button className="btn btn-sm btn-danger" onClick={function() { setShowForm(false); setEditId(null); }}>Close</button>
          </div>

          {/* Quick City Search - auto fills lat/lng */}
          <div style={{ marginBottom: 16, padding: 14, background: '#f0f7ff', borderRadius: 10, border: '1px solid #d0e4ff' }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#1565c0', display: 'block', marginBottom: 6 }}>Quick Add: Search city name (auto-fills coordinates)</label>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={cityQuery}
                onChange={function(e) { searchCity(e.target.value); }}
                placeholder="Type city name (e.g. Sircilla, Warangal, Huzurabad)..."
                style={{ flex: 1, padding: '9px 12px', border: '1px solid #ccc', borderRadius: 8, fontSize: 14 }} />
              {searching && <span style={{ alignSelf: 'center', fontSize: 12, color: '#888' }}>Searching...</span>}
            </div>
            {cityResults.length > 0 && (
              <div style={{ marginTop: 8, border: '1px solid #e0e0e0', borderRadius: 8, overflow: 'hidden' }}>
                {cityResults.map(function(city, i) {
                  return (
                    <div key={i} onClick={function() { selectCity(city); }}
                      style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                      <strong style={{ color: '#1a1a2e' }}>{city.name}</strong>
                      <span style={{ fontSize: 11, color: '#666', marginLeft: 10 }}>({city.lat.toFixed(4)}, {city.lng.toFixed(4)})</span>
                      <div style={{ fontSize: 10, color: '#999', marginTop: 2 }}>{city.fullName}</div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <form onSubmit={handleAdd} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            <div className="form-group">
              <label>District</label>
              <input value={form.district} onChange={function(e) { setForm(Object.assign({}, form, { district: e.target.value })); }} placeholder="e.g. Karimnagar" required />
            </div>
            <div className="form-group">
              <label>City/Town</label>
              <input value={form.city} onChange={function(e) { setForm(Object.assign({}, form, { city: e.target.value })); }} placeholder="e.g. Siricilla" required />
            </div>
            <div className="form-group">
              <label>Area Code (for Order IDs)</label>
              <input value={form.area_code} onChange={function(e) { setForm(Object.assign({}, form, { area_code: e.target.value.toUpperCase() })); }} placeholder="e.g. HYD, KNR, PTN" maxLength="5" style={{textTransform:'uppercase'}} />
            </div>
            <div className="form-group">
              <label>Latitude</label>
              <input type="number" step="any" value={form.latitude} onChange={function(e) { setForm(Object.assign({}, form, { latitude: e.target.value })); }} placeholder="18.43" required />
            </div>
            <div className="form-group">
              <label>Longitude</label>
              <input type="number" step="any" value={form.longitude} onChange={function(e) { setForm(Object.assign({}, form, { longitude: e.target.value })); }} placeholder="79.12" required />
            </div>
            <div className="form-group">
              <label>Radius (km)</label>
              <input type="number" value={form.radius_km} onChange={function(e) { setForm(Object.assign({}, form, { radius_km: e.target.value })); }} placeholder="10" required />
            </div>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
              <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : (editId ? 'Update Area' : 'Add Area')}</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <div className="loading">Loading areas...</div> : (
        Object.keys(districts).length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: 40 }}>
            <p style={{ fontSize: 48, margin: 0 }}>📍</p>
            <h3>No service areas added yet</h3>
            <p style={{ color: '#888' }}>Click "+ Add Area" to add districts and cities</p>
          </div>
        ) : (
          Object.entries(districts).map(function([district, cities]) {
            var activeCount = cities.filter(function(c) { return c.is_active; }).length;
            return (
              <div className="card" key={district} style={{ marginBottom: 16 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <h3 style={{ margin: 0 }}>{district}</h3>
                    <span style={{ fontSize: 12, color: '#888' }}>{activeCount}/{cities.length} active</span>
                  </div>
                  <button className={'btn btn-sm ' + (activeCount > 0 ? 'btn-danger' : 'btn-success')}
                    onClick={function() { handleDistrictToggle(district); }}>
                    {activeCount > 0 ? 'Deactivate All' : 'Activate All'}
                  </button>
                </div>
                <div className="table-wrapper">
                  <table>
                    <thead>
                      <tr>
                        <th>City/Town</th>
                        <th>Latitude</th>
                        <th>Longitude</th>
                        <th>Radius</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cities.map(function(a) {
                        return (
                          <tr key={a.id}>
                            <td style={{ fontWeight: 600 }}>{a.city}</td>
                            <td>{a.latitude}</td>
                            <td>{a.longitude}</td>
                            <td>{a.radius_km} km</td>
                            <td>
                              <span className={'badge ' + (a.is_active ? 'badge-success' : 'badge-grey')}>
                                {a.is_active ? 'Active' : 'Inactive'}
                              </span>
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: 6 }}>
                                <button className={'btn btn-sm ' + (a.is_active ? 'btn-warning' : 'btn-success')}
                                  onClick={function() { handleToggle(a.id); }}>
                                  {a.is_active ? 'OFF' : 'ON'}
                                </button>
                                <button className="btn btn-sm btn-primary" onClick={function() { handleEdit(a); }}>Edit</button>
                                <button className="btn btn-sm btn-danger" onClick={function() { handleDelete(a.id, a.city); }}>Del</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })
        )
      )}
    </div>
  );
}
